export default "__VITE_ASSET__DNgaajXo__"